import { executeRequest, JFSRequest } from '@jfs/network'
import { clean, formatDate, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    content: data?.content?.map((item: any) => ({
      ID: '' + item?.id,
      id: '' + item?.id,
      merchantId: item?.merchantId,
      processingEntity: item?.processingEntity ?? 'NA',
      bankMerchantId: item?.bankMerchantId ?? 'NA',
      terminalId: item?.terminalId ?? 'NA',
      bankTerminalId: item?.bankTerminalId ?? 'NA',
      transactionType: item?.transactionType ?? 'NA',
      transactionMode: item?.transactionMode ?? 'NA',
      transactionSubType: item?.transactionSubType ?? 'NA',
      status: item?.status ?? 'NA',
      createdAt: formatDate(item?.createdAt) ?? 'NA',
      updatedAt: formatDate(item?.updatedAt) ?? 'NA',
      createdBy: item?.createdBy ?? 'NA',
      updatedBy: item?.updatedBy ?? 'NA',
      processingEntityMidTidConfiguration: item?.processingEntityMidTidConfiguration,
    })),
  }
}

const getAllMerchants = (data: any, paginationInfo: any, tokens: any) => {
  const processingEntity = data.processingEntity ? data.processingEntity.split('-')[0] : undefined
  const modifiedData = { ...data, processingEntity }
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getAllMerchantMapping),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      inputFilter: {
        ...clean(modifiedData),
      },
      configParams: paginationInfo,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllMerchants }
